import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "xpage-breadcrumbs" }




export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageBreadcrumbs',
  props: {
	pageName: {
		type: String,
		default: "",
	},
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "icon-home"
    }),
    _cache[0] || (_cache[0] = _createElementVNode("span", null, ">", -1)),
    _createVNode(_component_router_link, {
      to: `/${props.pageName.toLowerCase()}`
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.pageName), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})